module.exports = __webpack_public_path__ + "media/images/official/special_workcation_mochimuneb_03-38e8747596bc9e87b09db0807b9fc1f3.jpeg";